import React from "react";
import styles from "@src/components/helpers.module.scss";
import { IIconActiveProps } from "./helpers";

export const EventsIcon: React.FC<IIconActiveProps> = ({ isActive }) => {
	return (
		<div className={styles.iconContainer}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_1207_4373)">
					<path
						d="M16.2501 1.66562H15.5556V1.11015C15.5556 0.803121 15.3072 0.554688 15.0001 0.554688C14.6931 0.554688 14.4447 0.803121 14.4447 1.11015V1.66562H5.55568V1.11015C5.55568 0.803121 5.30725 0.554688 5.00021 0.554688C4.69318 0.554688 4.44475 0.803121 4.44475 1.11015V1.66562H3.751C1.98933 1.66562 0.555664 3.09922 0.555664 4.86095V16.2491C0.555664 18.0101 1.98926 19.4438 3.75033 19.4438H16.2495C18.0112 19.4438 19.4448 18.0102 19.4448 16.2491V4.86095C19.4448 3.09929 18.0112 1.66562 16.2501 1.66562ZM18.3338 16.2493C18.3338 17.3977 17.3987 18.333 16.2501 18.333H3.75015C2.60171 18.333 1.66648 17.3978 1.66648 16.2493V7.22112H18.3328L18.3338 16.2493ZM18.3338 6.11029H1.66715V4.86029C1.66715 3.71185 2.6023 2.77745 3.75081 2.77745H4.44535V3.88839C4.44535 4.19542 4.69378 4.44385 5.00081 4.44385C5.30785 4.44385 5.55628 4.19542 5.55628 3.88839V2.77745H14.4453V3.88839C14.4453 4.19542 14.6937 4.44385 15.0007 4.44385C15.3078 4.44385 15.5562 4.19542 15.5562 3.88839V2.77745H16.25C17.3992 2.77745 18.3343 3.71182 18.3343 4.86112L18.3338 6.11029Z"
						fill={isActive ? "var(--activeIcon)" : "var(--inactiveIcon)"}
					/>
					<path
						d="M7.86236 13.4734L7.54829 15.3054C7.47095 15.7585 7.94751 16.1054 8.35454 15.8913L9.99986 15.0265L11.6452 15.8913C12.053 16.1054 12.5288 15.7577 12.4514 15.3054L12.1374 13.4734L13.4686 12.1757C13.7975 11.8546 13.6155 11.2945 13.1608 11.2281L11.321 10.9609L10.4983 9.29375C10.2952 8.88125 9.70534 8.88125 9.50221 9.29375L8.67956 10.9609L6.83973 11.2281C6.38504 11.2945 6.20223 11.8547 6.53191 12.1757L7.86236 13.4734Z"
						fill={isActive ? "var(--activeIcon)" : "var(--inactiveIcon)"}
					/>
				</g>
				<defs>
					<clipPath id="clip0_1207_4373">
						<rect width="20" height="20" fill={isActive ? "var(--activeIcon)" : "var(--inactiveIcon)"} />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};
